const Auth = {
    guest: () => window.Laravel.guest,
    is: (role) => (window.Laravel.roles.indexOf(role) != -1),
    user: (window.Laravel) ? window.Laravel.user : null,
    isAdmin: () => {
        return Auth.is('programmer') || Auth.is('studymanager')
    }
}

export default Auth;